import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { SpotStore } from './spotIndia.types';

const useSpotIndiaStoreBase = create<SpotStore>()(
  devtools(
    set => ({
      state: {
        spotPrices: {},
        spotTickerData: {},
      },
      actions: {
        updateSpotPrices: prices =>
          set(
            store => ({
              state: {
                ...store.state,
                spotPrices: { ...store.state.spotPrices, ...prices },
              },
            }),
            false,
            'updateSpotPrices'
          ),
        updateSpotTickerData: tickerData =>
          set(
            store => ({
              state: {
                ...store.state,
                spotTickerData: { ...store.state.spotTickerData, ...tickerData },
              },
            }),
            false,
            'updateSpotTickerData'
          ),
      },
    }),
    {
      name: 'SpotIndiaStore',
    }
  )
);

export { useSpotIndiaStoreBase };
